import { gql } from "@apollo/client"

export const CURRENT_USER = gql`
query me {
  me {
    id
    userId
    displayName
    email
    coins
    totalXps
		stars
		level
		levelPercentage
    isMeta
    dailyActivityAnswered
    dailyChallengeAnswered
    notificationToken
  }
}
`

export const USER_PROFILE = gql`
query userProfile {
  me {
    id
    userId
    firstName
    lastName
    displayName
    email
    coins
    standard {
      value
    }
    phoneNumber
    address1
    address2
    city
    state
    country
    postcode
    schoolText
    isHomeschooler
    dob
    allowStandardUpdate
    profileImage
  }
}`
